function getBmi({ weight: weightProps, height: heightProps, }) {
    const height = heightProps / 100;
    const weight = weightProps;
    return Math.round((weight / (height * height)) * 10) / 10;
}

export { getBmi };
